import type {FC, ReactNode} from 'react';

export interface RosterPaneProps {
  active: boolean;
  children: ReactNode;
}

/** Hides instead of unmounting, so inactive rows keep their form registration and validation. */
export const RosterPane: FC<RosterPaneProps> = ({active, children}) => (
  <div data-slot="roster-pane-item" hidden={!active} className="flex flex-col gap-6">
    {children}
  </div>
);
